import React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";

import { selector } from "../";
import { Modal } from "../../components";
import * as action from "../../redux/actionCreators/guestlist";
import { type IEntryType, type IRow } from "../index";
import { TypeSettingsRow } from "./index";

interface IProps {
  guestlist: server.dto.LegacyGuestlist
  entryTypes: IEntryType[]
  currentEditedRow: IRow
  shouldShowPlaceDeleteModal: boolean
}

interface IDispatch {
  addGuestlistPlace: (place: server.dto.LegacyGuestlistPlace) => any
  removeGuestlistPlace: (placeId: number) => any
  fetchGuestlist: (showId: number) => any
  setCurrentEditedRow: (row: IRow) => any
  stopShowingDeleteModal: () => any
}

const mapStateToProps = (state): IProps => ({
  currentEditedRow: selector.getCurrentEditedRow(state),
  entryTypes: selector.getEntryTypes(state),
  guestlist: selector.getGuestlist(state),
  shouldShowPlaceDeleteModal: selector.shouldShowPlaceDeleteModal(state)
});

const mapDispatchToProps = (dispatch): IDispatch => ({
  addGuestlistPlace: (place: server.dto.LegacyGuestlistPlace) => dispatch(action.addGuestlistPlace(place)),
  fetchGuestlist: (showId: number) => dispatch(action.fetchGuestlist(showId)),
  removeGuestlistPlace: (placeId: number) => dispatch(action.removeGuestlistPlace(placeId)),
  setCurrentEditedRow: (row: IRow) => dispatch(action.setCurrentEditedGuestlistPlace(row)),
  stopShowingDeleteModal: () => dispatch(action.setShowDeleteModal(false))
});

const NEW_ROW_ID: number = -1;

class TypeSettings extends React.Component<IProps & IDispatch> {
  private DefaultNewRow: IRow;
  private rows: IRow[];

  componentDidMount() {
    const defaultEntryType: IEntryType = { type: -1, name: "" };
    this.DefaultNewRow = { id: NEW_ROW_ID, persons: 1, entryType: defaultEntryType, place: null };

    this.createRows();

    // If there are no rows, automatically start creating a new one
    if (this.props.currentEditedRow == null && this.rows.length === 0) {
      this.onInitNewRow();
    }
  }

  private readonly onPlaceDelete = () => {
    if (this.props.currentEditedRow == null && this.rows.length === 0) {
      this.onInitNewRow();
    }
  };

  private readonly createRows = () => {
    const places = this.props.guestlist.availablePlaces;

    const rows: IRow[] = places.map((place, id) => {
      const entryType: IEntryType = { type: place.entryType.type, name: place.entryType.name };
      return {
        entryType,
        id,
        place,
        persons: place.availableSpots
      };
    });

    this.rows = rows;
  };

  private readonly buildRows = (): JSX.Element => {
    this.createRows();
    const rows: IRow[] = this.rows;

    return (<div className="flex-column gap">
      {rows.map((row) =>
        <TypeSettingsRow
          key={row.place.guestlistPlaceId}
          row={row}
          onPlaceDelete={this.onPlaceDelete}
          getEntryTypes={this.getDefaultEntryTypes}
          getUnusedEntryTypes={this.getUnusedEntryTypes}
        />)}
      {(this.props.currentEditedRow?.id === NEW_ROW_ID) &&
        <TypeSettingsRow
          onPlaceDelete={() => { }}
          row={this.props.currentEditedRow}
          getEntryTypes={this.getDefaultEntryTypes}
          getUnusedEntryTypes={this.getUnusedEntryTypes}
        />}
      {(this.props.currentEditedRow == null) &&
        <div className="margin-top">
          <Button
            onClick={this.onInitNewRow}
            fluid
            color="blue"
          >
            {RESX.Guestlist.PlaceAddButton}
          </Button>
        </div>
      }
    </div>);
  };

  private readonly onInitNewRow = () => {
    this.props.setCurrentEditedRow(this.DefaultNewRow);
  };

  private readonly getDefaultEntryTypes = (): IEntryType[] => this.props.entryTypes;

  private readonly getUnusedEntryTypes = (): IEntryType[] => {
    const defaultEntryTypes = this.getDefaultEntryTypes();
    const usedEntryTypes = this.rows
      .map((row) => row.entryType);

    // The difference between defaultEntries and usedEntries
    const difference = defaultEntryTypes
      .filter((entry) => usedEntryTypes.find((used) => entry.type === used.type) == null)
      .filter((entry) => entry.type !== 255);

    difference.push({ name: "Other", type: 255 });

    return difference;
  };

  public render(): JSX.Element {
    return (<>
      <Modal title={RESX.GeneralLabels.Delete}
        isOpen={this.props.shouldShowPlaceDeleteModal}
        handleClose={this.props.stopShowingDeleteModal}
      >
        {RESX.GuestlistErrors.ListContainsGuests}
      </Modal>
      {this.buildRows()}
    </>);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TypeSettings);
